<input
  type="text"
  (focusout)="onFocusOut($event)"
  [maxlength]="maxLength"
  class="lau-NumericCellEditor-input"
  #input
  (keydown)="onKeyDown($event)"
  [(ngModel)]="value"
/>
